import React, {useCallback, useState} from "react";
import {Button} from "@reside/ui";
import {connect} from "react-redux";
import {useQueryClient} from "react-query";

import {select} from "../../store";
import {SimpleFacilityModel} from "../../utils/types/facility";
import {WorkflowService} from "../../services/WorkflowService";

import {StartWorkflowModal} from "./StartWorkflowModal";
import {facilityWorkflowsQueryKey} from "./hooks/useFacilityWorkflowsQuery";
import {getSingleFacility} from "./resolveActiveFacilityId";

type Props = Readonly<{
  facilities: ReadonlyArray<SimpleFacilityModel>;
}>;

export const Renderer = ({facilities = []}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();
  const safeFacilities = facilities ?? [];
  const singleFacility = getSingleFacility(safeFacilities);

  const handleOpen = useCallback(() => {
    if (singleFacility) {
      void queryClient.prefetchQuery(
        facilityWorkflowsQueryKey(singleFacility.id),
        () => WorkflowService.getFacilityWorkflows(singleFacility.id),
      );
    }

    setIsOpen(true);
  }, [queryClient, singleFacility]);

  if (safeFacilities.length === 0) {
    return null;
  }

  return (
    <>
      <Button
        color="primary"
        outline
        testId="createNewButton"
        onClick={handleOpen}
      >
        Start new
      </Button>
      <StartWorkflowModal
        facilities={safeFacilities}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
      />
    </>
  );
};

const mapStateToProps = (state: any) => ({
  facilities: select.adminSession.facilities(state),
});

export const StartWorkflowButton = connect(mapStateToProps)(Renderer);
